module.exports = __webpack_public_path__ + "../resources/img/bg_pv2_03.7c60e4ca.png";